import React, { useState, useRef, useEffect } from "react";
import AddressInput from "./AddressInput";
import BackHeader from "./BackHeader";
import { Icons } from "../assets/icons/Icons";
import { Header } from "../layouts/Header";
import Button from "./Button";
import TransactionModal from "./TransactionModal";
import CryptoDropdown from "./CryptoDropdown";
import NetworkDropdown from "./NetworkDropdown";
import { useFunds } from "../service";

export const TransferFunds = () => {
  const divRef = useRef(null);

  const [account, setAccount] = useState("Main Account");

  const [address, setAddress] = useState("");
  const [otherAddress, setOtherAddress] = useState("");
  const [amount, setAmount] = useState("150.00");
  const [idNumber, setIdNumber] = useState("");

  const [selectedCrypto, setSelectedCrypto] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [accepted, setAccepted] = useState(false);
  const [errors, setErrors] = useState({});

  const { transferFunds } = useFunds();

  useEffect(() => {
    const preventScroll = (event) => {
      event.preventDefault();
    };

    const div = divRef.current;
    if (div) {
      div.addEventListener("wheel", preventScroll, { passive: false });
    }

    return () => {
      if (div) {
        div.removeEventListener("wheel", preventScroll);
      }
    };
  }, []);

  const validate = () => {
    let newErrors = {};
    if (!idNumber) newErrors.idNumber = true;
    if (!amount) newErrors.amount = true;
    if (!accepted) newErrors.accepted = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleTransfer = () => {
    closeModal();
    if (!validate()) return;
    transferFunds.mutate(account, idNumber, amount);
    setAccount("Main Accoun");
    setIdNumber("");
    setAmount("");
    setAccepted(false);
    ModalClose();
  };

  const ModalClose = () => {
    const modalCloseButton = document.querySelector(
      "#menu-transfer .btn-close"
    );
    if (modalCloseButton) {
      modalCloseButton.click();
    }
  };

  const handleInputChange = (setter, field) => (e) => {
    setter(e.target.value);
    setErrors((prev) => ({ ...prev, [field]: false }));
  };

  const handleCheckboxChange = (e) => {
    setAccepted(e.target.checked);
    setErrors((prev) => ({ ...prev, accepted: false }));
  };

  const handleCryptoSelect = (crypto) => {
    setSelectedCrypto(crypto);
    console.log("Selected crypto:", crypto);
  };
  const handleNetworkSelect = (network) => {
    setSelectedNetwork(network);
    console.log("Selected network:", network);
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const handleOtherAddresstChange = (newAmount) => {
    setOtherAddress(newAmount);
  };

  const handleChangeClick = () => {
    // Open amount selection modal or other action
    console.log("Change amount clicked");
  };

  const handleWithdraw = () => {
    closeModal();
  };

  const transactionDetails = [
    { label: "Amount", value: "$1500.00" },
    { label: "Admin fees", value: "$1.00" },
    { label: "Payment time", value: "14:54pm" },
    { label: "Payment date", value: "17 Apr 2024" },
  ];

  return (
    <div
      ref={divRef}
      className="offcanvas offcanvas-top"
      id="menu-transfer"
      style={{
        height: "100vh",
        background: "#000",
        padding: "30px 18px",
        width: "100%",
        overflowY: "hidden",
        zIndex: "9999",
        backgroundImage: "url('./images/store/notification_bg.png')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0px 0px",
        backgroundSize: "contain",
        backgroundColor: "#000000",
      }}
    >
      <div className="offcanvas-header">
        <button
          type="button"
          className="btn-close opacity-1"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          style={{ display: "none" }}
        ></button>

        <div onClick={ModalClose} style={{ cursor: "pointer" }}>
          <Icons.BackWithBG />
        </div>
        <h2 className="font-33 font-700" style={{ marginLeft: "12px" }}>
          Deposit Funds
        </h2>
      </div>
      <div style={{ paddingTop: "20px" }}>
        <CryptoDropdown label="CHOOSE CRYPTO" onSelect={handleCryptoSelect} />

        <NetworkDropdown
          label="CHOOSE NETWORK"
          onSelect={handleNetworkSelect}
          id={selectedCrypto?.id ?? "btc"}
        />

        <AddressInput
          type="address"
          label="ADRESS"
          placeholder="Adress"
          value={address}
          onChange={handleAddressChange}
        />

        <AddressInput
          type="address"
          label="YOUR ADRESS"
          placeholder="Enter Your Adress"
          value={otherAddress}
          onChange={handleOtherAddresstChange}
        />

        <div
          style={{
            position: "absolute",
            bottom: "25px",
          }}
        >
          <div
            className="form-check mt-3 mb-3"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <input
              className={`form-check-input ${
                errors.accepted ? "border-danger" : ""
              }`}
              type="checkbox"
              checked={accepted}
              onChange={handleCheckboxChange}
              style={{ marginTop: "6px" }}
            />
            <label
              className="font-13 font-500"
              style={{ color: "#C3C4FF", paddingLeft: "7px" }}
            >
              I Accept The Treams Of Service
            </label>
          </div>
          <div className="text-center" style={{ width: "342px" }}>
            <Button onClick={openModal}>Deposit Funds</Button>
          </div>
        </div>
      </div>
      <TransactionModal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Transition Details"
        details={transactionDetails}
        total="$1501.00"
        actionText="Withdraw"
        onAction={handleTransfer}
      />
    </div>
  );
};
